import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Reintentar un 401/403/404 solo genera ruido: el fallo no es transitorio.
        const status = error?.status ?? 0
        if (status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
    mutations: { retry: 0 },
  },
})
